import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      leafContainer: this.el.querySelector('.explore-all-four__leaf'),
      container: this.el
    };
    this.setupMinHeight();
  }

  addListeners() {
    window.addEventListener('resize', e => this.setupMinHeight())
  }

  setupMinHeight() {
    const minHeight = this.dom.leafContainer.offsetHeight;
    this.dom.container.style.minHeight = `${minHeight}px`
  }
}

export default Module;
